import React, { useContext, useEffect, useRef, useState } from "react";

// icons
import Back from "../../../assets/icons/icon_back.png";

import { MyContext } from "../../../context/MyContext";
import SelectBox from "../../../components/SelectBox";
import { backIncstance, fileUpload } from "../../../utils/commonFunctions";
import { useLocation } from "react-router-dom/dist";
import Warning from "../../../components/Warning";

const URLS = {
  CLARIO: process.env.REACT_APP_SOCRATES_SERVER,
  START_INTERVIEW: process.env.REACT_APP_SOCRATES_STRAT_INTERVIEW,
  GROUP_RESULT: process.env.REACT_APP_SOCRATES_GET_GROUP_RESULT,
  STORAGE_RESULT: process.env.REACT_APP_SOCRATES_GET_STORAGE_RESULT,
  GET_KIND: process.env.REACT_APP_SOCRATES_GET_KIND,
  INTERESTING: process.env.REACT_APP_SOCRATES_GET_INTERESTING,
  GROUP_LIST: process.env.REACT_APP_SOCRATES_GET_GROUP_LIST, // 소크라테스 그룹 조회
  EDIT_GROUP_LIST: process.env.REACT_APP_SOCRATES_EDIT_GROUP_LIST, // 소크라테스 그룹 생성, 변경 및 삭제
  CHAT_HISTORY: process.env.REACT_APP_SOCRATES_GET_HISTORY_LIST, // 소크라테스 목록의 채팅 조회 및 체팅추가
  GET_STORAGE_LIST: process.env.REACT_APP_SOCRATES_GET_STORAGE_LIST, // 소크라테스 목록 조회
  EDIT_STORAGE: process.env.REACT_APP_SOCRATES_EDIT_STORAGE_LIST, // 소크라테스 보관함 채팅 목록 조회, 생성 및 변경
  STORAGE_LIST: process.env.REACT_APP_SOCRATES_GET_STOARGE_GROUP_LIST, // 소크라테스 보관함 채팅 목록 조회
  CLARIO_EVALUATION: process.env.REACT_APP_SOCRATES_EVALUATION, // 소크라테스 question_count당 평가 전송
  BACK_EVALUATION: process.env.REACT_APP_SOCRATES_SAVE_EAVALUTION,
  UPLOAD_FILE: process.env.REACT_APP_SOCRATES_UPLOAD,
  ADD_FORM: process.env.REACT_APP_SOCRATES_CREATE_FORM,
  GET_FORM_LIST: process.env.REACT_APP_SOCRATES_GET_FORM,
};

const Form = (props) => {
  const location = useLocation();

  const { user, setAlertSetting } = useContext(MyContext);
  const { state, dispatch, clearCustomData, handleSubmitForm } = props;
  const fileRef = useRef(null);
  const customRef = useRef(null);

  const [interestingList, setInterestingList] = useState([]); // 관심있는 영역 및 진로학과 리스트
  const [interviewCategory, setInterViewCategory] = useState([]); // 면접 유형 리스트

  const [interviewInfo, setInterviewInfo] = useState({
    favorite_subject: "",
    favorite_topic: "",
    interview_category: "",
    interviewing_institution: "",
    user_input: "",
    special_request: "",
  });
  const checkInputValues = () => {
    const inputs = customRef.current.querySelectorAll(
      'input:not([id^="react-select-"])'
    );
    const formData = {};

    let text = "";
    if (interviewInfo?.interview_category === "") {
      text = "면접 유형을 선택해주세요.";
    } else if (interviewInfo?.interviewing_institution === "") {
      text = "지원하는 기관을 입력해주세요.";
    } else if (interviewInfo?.favorite_topic === "") {
      text = "관심있는 영역 및 진로학과를 선택해주세요.";
    } else if (interviewInfo?.favorite_subject === "") {
      text = "관심있는 주제를 입력해주세요.";
    } else if (interviewInfo?.user_input === "") {
      text = "원하는 스타일을 입력해주세요.";
    }
    setWarnSetting((prev) => ({
      ...prev,
      warningTxt: text,
      onClose: () => {
        // 기존 onClose 함수 실행
        if (typeof prev.onClose === "function") {
          prev.onClose();
        }
        // 새로운 기능 추가
        text = "";
      },
    }));
    if (text !== "") return;

    handleSubmitForm(interviewInfo);
  };

  const touchAPI = async (method, url, data) => {
    try {
      const response = await backIncstance(method, url, data);
      const resData = await response.json();
      if (url === URLS.INTERESTING) {
        const listData = resData?.inter_area_list.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setInterestingList(listData);
      } else if (url === URLS.GET_KIND) {
        const listData = resData?.kind_list;
        setInterViewCategory(listData);
      } else if (url === URLS.START_INTERVIEW) {
        // setIsAddingMode(true)
        // checkInputValues()
      }
    } catch (err) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: "닫기",
      }));
    }
  };

  const [uploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState("");
  const handleFile = async (e, target) => {
    if (target.includes("clear")) {
      if (interviewInfo?.special_request !== "") {
        fileRef.current.value = "";
        setInterviewInfo((prev) => ({
          ...prev,
          special_request: "",
        }));
        // dispatch({
        //   type: 'UPDATE_FILE',
        //   payload: {
        //     special_request: ''
        //   }
        // })
      }
    } else {
      const file = fileRef.current.files[0];
      const formData = new FormData();
      formData.append("file", file);
      if (file) {
        setFileName(file.name);
      }
      const url = URLS.UPLOAD_FILE;
      try {
        const response = await fileUpload("POST", url, formData);
        const resData = await response?.json();
        if (resData.detail) {
          setWarnSetting((prev) => ({
            ...prev,
            warningTxt:
              "hwp(x), doc(x), pdf, xlsx, txt 형식의 파일만 업로드 가능합니다. ",
          }));
          fileRef.current.files = [];
        } else {
          const result = resData.result;
          setInterviewInfo((prev) => ({
            ...prev,
            special_request: result,
          }));
          // dispatch({
          //   type: 'UPDATE_FILE',
          //   payload: {
          //     special_request: result
          //   }
          // })
        }
      } catch (err) {
        setWarnSetting((prev) => ({
          ...prev,
          warningTxt: "다시 시도해주세요.",
        }));
        setInterviewInfo((prev) => ({
          ...prev,
          special_request: "",
        }));
        if (fileRef.current) {
          // fileRef.current.files = []
        }
      } finally {
        setUploading(false);
      }
    }
  };

  const selectInterviewCategory = (value) => {
    // dispatch({
    //   type: 'SELECT_CATEGORY',
    //   payload: {
    //     interview_category: id
    //   }
    // })
    setInterviewInfo((prev) => ({
      ...prev,
      interview_category: value,
    }));
  };

  const selectFavTopic = (e) => {
    // dispatch({
    //   type: 'SELECT_TOPIC',
    //   payload: {
    //     favorite_topic: e.value
    //   }
    // })
    setInterviewInfo((prev) => ({
      ...prev,
      favorite_topic: e.label,
    }));
  };

  useEffect(() => {
    touchAPI("GET", URLS.INTERESTING);
    touchAPI("GET", URLS.GET_KIND);

    // const params = location.pathname.split('/')[3];
    // if (params) {
    //   const startData = {
    //     user_pk: user.id,
    //     group_id: Number(params)
    //   }
    //   touchAPI('POST', URLS.START_INTERVIEW, startData)
    // }
  }, [location]);

  /**
   * warning Handler
   */
  const clearWarnState = () => {
    setWarnSetting({
      ...warnSetting,
      warningTxt: "",
    });
    setIsWarning(false);
  };
  const [isWarning, setIsWarning] = useState(false);
  const [warnSetting, setWarnSetting] = useState({
    warningTxt: "",
    onClose: () => clearWarnState(),
  });
  useEffect(() => {
    if (warnSetting.warningTxt !== "") {
      setIsWarning(true);
    }
  }, [warnSetting.warningTxt]);

  return (
    <div className="ctn-wrp form-wrp">
      <div className="custom-socrates">
        <div className="flx-box inputs">
          <div className="back_btn crs-btn" onClick={() => clearCustomData()}>
            <img src={Back} alt="move-to-back" />
          </div>
          <h1 className="custom-title">🎓 나만의 소크라테스를 만들어보세요.</h1>
          <ul className="custom-list" ref={customRef}>
            <li className="list-item">
              <div className="list-title">원하는 면접 유형을 선택하세요.</div>
              <div className="interview-category__wrp">
                {interviewCategory?.map((interviewItem, interviewIdx) => {
                  return (
                    // <div onClick={() => setQueryString(prev => ({ ...prev, interview_info: { ...prev.interview_info, interview_category: interviewItem.id } }))} className={`interview-category crs-btn ${interviewInfo?.interview_category === interviewItem.id ? 'selected' : ''}`} key={`interview-category-${interviewIdx + 1}`}>{interviewItem.name}</div>
                    <div
                      onClick={() =>
                        selectInterviewCategory(interviewItem.name)
                      }
                      className={`interview-category crs-btn ${
                        interviewInfo?.interview_category === interviewItem.name
                          ? "selected"
                          : ""
                      }`}
                      key={`interview-category-${interviewIdx + 1}`}
                    >
                      {interviewItem.name}
                    </div>
                  );
                })}
              </div>
            </li>
            <li className="list-item">
              <div className="list-title">지원하는 기관명을 입력하세요.</div>
              <input
                name="interviewing_institution"
                placeholder="ex) 서울시교육청 영재교육원"
                onChange={(e) =>
                  setInterviewInfo((prev) => ({
                    ...prev,
                    interviewing_institution: e.target.value,
                  }))
                }
                required
              />
            </li>
            <li className="list-item">
              <div className="list-title">
                관심있는 영역 및 진로학과를 선택하세요.
              </div>
              {/* <SelectBox handleChange={(e) => setQueryString(prev => ({ ...prev, interview_info: { ...prev.interview_info, favorite_topic: e.value } }))} noRadius options={interestingList} mainColor="#4B4DA0" subColor="#EFEFF7" /> */}
              <SelectBox
                handleChange={(e) => selectFavTopic(e)}
                noRadius
                options={interestingList}
                mainColor="rgba(51, 51, 51, 1)"
                subColor="rgba(99, 105, 251, 1)"
              />
            </li>
            <li className="list-item">
              <div className="list-title">
                관심있는 주제의 키워드를 입력하세요.
              </div>
              <input
                name="favorite_subject"
                maxLength={200}
                placeholder="쉼표(,)로 구분해 주세요. 여러 가지 키워드를 입력할 수 있어요."
                onChange={(e) =>
                  setInterviewInfo((prev) => ({
                    ...prev,
                    favorite_subject: e.target.value,
                  }))
                }
                required
              />
            </li>
            <li className="list-item">
              <div className="list-title">
                자기소개 또는 탐구 보고서가 있다면 파일을 업로드해주세요.
              </div>

              <div className="flx-box">
                <input
                  className="special_request"
                  accept=".pdf, .xlsx, .txt"
                  value={
                    fileName
                      ? fileName
                      : "업로드 가능한 파일 형식: hwp(x), doc(x), pdf, xlsx, txt"
                  }
                  placeholder="첨부파일"
                  id="react-select-"
                  readOnly
                />
                <label className="btn-label" htmlFor="file_upload">
                  파일 업로드
                </label>
              </div>
              <input
                type="file"
                id="file_upload"
                ref={fileRef}
                onClick={(e) => handleFile(e, "clear")}
                // onChange={(e) => { setQueryString((prev) => ({ ...prev, interview_info: { ...prev.interview_info, special_request: e.target.value } })) }}
                onChange={(e) => handleFile(e, "upload")}
                required
              />
            </li>
            <li className="list-item">
              <div className="list-title">
                좀 더 구체적으로 원하는 스타일이 있다면 적어주세요.
              </div>
              <input
                name="user_input"
                placeholder="ex) 관심있는 주제 위주로 질문해 줘. 초등학생 수준에 맞게 질문해 줘."
                onChange={(e) =>
                  setInterviewInfo((prev) => ({
                    ...prev,
                    user_input: e.target.value,
                  }))
                }
                required
              />
            </li>
          </ul>

          <button className="crs-btn" onClick={checkInputValues}>
            모의 면접 시작 🙂
          </button>
        </div>
      </div>
      {isWarning && <Warning settings={warnSetting} />}
    </div>
  );
};
export default Form;
